import React, { FunctionComponent } from 'react'
import classnames from 'classnames'

import { displaySnakeCaseAsTitleCase } from '../../helpers/displayFormatHelper'
import { CheckMark } from '../../icons/checkMark'
import { CancelX } from '../../icons/cancelX'

export interface Props {
  isSmall?: boolean
  status: string
  withIcon?: boolean
}

export const StatusPill: FunctionComponent<Props> = ({
  isSmall,
  status,
  withIcon,
}) => {
  const statusColor = (status) => {
    // lowercase status = zendesk tickets
    switch (status) {
      case 'new':
      case 'open':
        return 'status-pill--blue'
      case 'ACCEPTED':
      case 'APPROVED':
      case 'CLOSING':
      case 'COMPLETE':
      case 'CURRENT':
      case 'OPEN':
      case 'SOLD':
      case 'solved':
      case 'closed':
        return 'status-pill--green'
      case 'ACCEPTED_OTHER':
      case 'CANCELLED':
      case 'EXPIRED':
      case 'INCOMPLETE':
      case 'REJECTED':
        return 'status-pill--red'
      case 'EXPLORING':
      case 'PENDING':
      case 'pending':
      case 'on-hold':
        return 'status-pill--yellow'
      case 'MISSING DATA':
        return 'status-pill--gray'
      default:
        return null
    }
  }

  const statusNegative =
    status === 'CANCELLED' || status === 'EXPIRED' || status === 'REJECTED'
      ? true
      : false

  return (
    <div
      data-testid="status-pill"
      className={classnames('status-pill', statusColor(status), {
        'status-pill--small': isSmall,
      })}
    >
      {withIcon && (
        <div className="status-pill__icon">
          {statusNegative ? (
            <CancelX color="#FFF" height="16px" width="16px" />
          ) : (
            <CheckMark color="#FFF" height="16px" width="16px" />
          )}
        </div>
      )}
      {displaySnakeCaseAsTitleCase(status)}
    </div>
  )
}

StatusPill.displayName = 'StatusPill'
